module.exports = __webpack_public_path__ + "static/img/video_customer_insights.10330213.png";